import { createApi } from "@reduxjs/toolkit/query/react";
import { qwFleet } from "../../app/clients/qwFleet";
import { axiosBaseQuery } from "../../app/store/baseQuery";

export const fleetBaseApi = createApi({
  reducerPath: "fleet",
  baseQuery: axiosBaseQuery(qwFleet),
  endpoints: (builder) => ({
    getUser: builder.query({
      keepUnusedDataFor: 86400,
      query: (id) => ({
        url: `/v1/users/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetUserQuery } = fleetBaseApi;
